import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Rfid: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-190v-30h160v-427c0-29.22-23.78-53-53-53h-427v240h-30v-270h457c45.77 0 83 37.23 83 83z' />
    <circle cx='150' cy='630' r='30' />
    <path d='m390 660h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m270 660h-30c0-66.17-53.83-120-120-120v-30c82.71 0 150 67.29 150 150z' />
    <path d='m360 660h-30c0-115.79-94.21-210-210-210v-30c64.11 0 124.38 24.96 169.71 70.29s70.29 105.6 70.29 169.71z' />
  </IconBase>
));

Rfid.displayName = 'Rfid';

export default Rfid;
